import { useRef, useState } from "react";
import * as XLSX from "xlsx";
import api from "../../../core/axios/axiosInstance";
import { showToast } from "../../../core/data/redux/slices/ToastSlice";
import { useDispatch } from "react-redux";

const AdminCaliforniaEmailNotifications = () => {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      setContacts(jsonData);
    };

    reader.readAsArrayBuffer(file);
  };

  const downloadSampleExcel = () => {
    const data = [
      { name: "John", email: "john@example.com" },
      { name: "Michel", email: "michel@example.com" },
      { name: "", email: "waqar@californiamedia.ae" },
      { name: "", email: "vipul@californiamediauae.com" },
      { name: "", email: "waqar.78692@yahoo.com" },
    ];

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

    XLSX.writeFile(workbook, "bulk_email_sample.xlsx");
  };
  const handleSendEmail = async () => {
    if (!subject || !body || contacts.length === 0) {
      alert("Please fill subject, body and upload Excel file");
      return;
    }

    const payload = {
      email_subject: subject,
      email_body: body,
      details: contacts.map((c) => ({
        name: c.name,
        email: c.email,
      })),
    };

    setLoading(true);
    try {
      console.log(payload, "payload for bulk email");

      const response = await api.post("/send-bulk-email", payload);
      console.log(response.data, "response from bulk email send");

      dispatch(showToast({ message: "Email Sent", variant: "success" }));
      setSubject("");
      setBody("");
      setContacts([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error(error);
      dispatch(showToast({ message: "Email not Sent", variant: "danger" }));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="card-title">Send Email Notification</h5>
              <button
                className="btn btn-link p-0 mb-3"
                onClick={downloadSampleExcel}
              >
                ⬇ Download Sample Excel
              </button>
            </div>
            <div className="mb-3">
              <label className="form-label">Subject</label>
              <input
                className="form-control"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Message Body (HTML allowed)</label>
              <textarea
                className="form-control"
                rows="5"
                value={body}
                onChange={(e) => setBody(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Upload Excel File</label>
              <input
                type="file"
                accept=".xlsx,.xls"
                className="form-control"
                onChange={handleFileUpload}
                ref={fileInputRef}
              />
            </div>
            {contacts.length > 0 && (
              <p className="text-muted">{contacts.length} contacts loaded</p>
            )}

            <button
              className="btn btn-success"
              onClick={handleSendEmail}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Email"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCaliforniaEmailNotifications;
